import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import Header from '../../components/Header';
import HeroSection from '../../sections/HeroSection';
import InfoSection from '../../sections/InfoSection';
import PhotoSection from '../../sections/PhotoSection';
import BeliefsSection from '../../sections/BeliefsSection';
import SermonSection from '../../sections/SermonSection';
import PastorsSection from '../../sections/PastorsSection';
import SupportSection from '../../sections/SupportSection';
import Footer from '../../components/Footer';

import './HomePage.scss';

const HomePage = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('seo_home_title')}</title>
                <meta name="description" content={t('seo_home_description')} />
                <meta property="og:title" content={t('seo_home_title')} />
                <meta property="og:description" content={t('seo_home_description')} />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header transparent />
            <HeroSection />
            <InfoSection />
            <PhotoSection />
            <BeliefsSection />
            <SermonSection />
            <PastorsSection />
            <SupportSection />
            <Footer />
        </>
    );
};

export default HomePage;
